<div class="th-menulevel">
  <div class="ir-btn ir-btn--big th-btn-menulevel" (click)="selectMenu(1)">
    <span>{{ 'menus.open-parts' | translate }} </span>
  </div>
  <!--inspection plugin part-->
  <div
    [permissions]="[['visible', 'manage.parts', inspection]]"
    class="ir-btn ir-btn--big th-btn-remove"
    (click)="selectMenu(3)"
  >
    <span>{{ 'menus.delete' | translate }} </span>
  </div>
  <!--point plugin part-->
  <!-- <div *ngIf="pointId !== '-1'" class="ir-btn ir-btn--big  th-btn-remove" (click)="selectMenu(3)">
        <span>{{ 'menus.delete' | translate  }} </span>
    </div> -->
  <div
    *ngIf="currentPerson?.isHost && isConnection"
    class="ir-btn ir-btn--big th-btn-menulevel"
    (click)="selectMenu(10)"
  >
    <span>{{ 'menus.edit-json' | translate }} </span>
  </div>
  <div *ngIf="isConnection" class="ir-btn ir-btn--big th-btn-menulevel" (click)="selectMenu(11)">
    <span>{{ 'menus.edit' | translate }} </span>
  </div>
</div>
